import { cardPaymentEventId } from "./card-payments";
import { validIsoDate, type PaymentDeadline } from "../functions/card-reminder-logic.js";

export async function savePaymentDeadline(uid: string, card: string, period: string, dueOn: string, expectedRevision: number, operationId: string): Promise<PaymentDeadline> {
  if (!/^(BBVA|AMEX Servicios|American Express Platinum Card|Scotiabank)$/.test(card)
    || !/^\d{4}-\d{2}-\d{2} al \d{4}-\d{2}-\d{2}$/.test(period)
    || !validIsoDate(period.slice(0,10)) || !validIsoDate(period.slice(-10)) || period.slice(0,10) > period.slice(-10)
    || !validIsoDate(dueOn) || !dueOn.startsWith("20") || dueOn <= period.slice(-10) || !Number.isInteger(expectedRevision)
    || !/^paymentreminder_[a-zA-Z0-9-]+$/.test(operationId)) throw new Error("Revisa la fecha límite: debe ser posterior al cierre del corte.");
  const [{ doc, runTransaction, Timestamp }, { firestore }] = await Promise.all([import("firebase/firestore"), import("./firebase")]);
  const id = cardPaymentEventId(card, period);
  const ref = (collection: string, id: string) => doc(firestore, "users", uid, collection, id);
  const requestKey = JSON.stringify({ card, period, dueOn, expectedRevision });
  return runTransaction(firestore, async tx => {
    const [operation, previous, payment] = await Promise.all([tx.get(ref("operations", operationId)), tx.get(ref("cardPaymentReminders", id)), tx.get(ref("cardPaymentEvents", id))]);
    if (operation.exists()) {
      if (operation.data().requestKey !== requestKey) throw new Error("El identificador corresponde a otra fecha.");
      return operation.data().result as PaymentDeadline;
    }
    if (payment.exists()) throw new Error("Este corte ya se pagó. Su fecha histórica se conserva.");
    if ((previous.data()?.revision ?? 0) !== expectedRevision) throw new Error("La fecha cambió. Actualiza y revisa nuevamente.");
    const result: PaymentDeadline = { id, card, period, dueOn, revision: expectedRevision + 1, updatedAt: new Date().toISOString() };
    tx.set(ref("cardPaymentReminders", id), { ...result, dueAt: Timestamp.fromDate(new Date(`${dueOn}T00:00:00Z`)) });
    tx.set(ref("operations", operationId), { id: operationId, kind: "card_payment_reminder", createdAt: result.updatedAt, requestKey, result });
    return result;
  });
}
